import { createAction, createReducer } from "@reduxjs/toolkit";

export interface LoadingState {
    loading: boolean;
    loadingText: string;
}

const initialState: LoadingState = {
    loading: false,
    loadingText: ""
}

export const loadingActions = {
    activate: createAction<string>('loading/activate'),
    close: createAction('loading/close')
}

export const loadingReducer = createReducer(
    initialState,
    (builder) => {
        builder.addCase(loadingActions.activate, (state, action) => {
            state.loading = true;
            state.loadingText = action.payload;
        }).addCase(loadingActions.close, (state, action) => {
            state.loading = false;
            state.loadingText = "";
        })
    }
)